import React, { Fragment, useContext } from "react";
import Toolbar, { ToolbarGroup } from "components/Toolbar/Toolbar";
import ToolbarButton from "components/Toolbar/ToolbarButton";
import {
    TrashIcon,
    SupportIcon,
    PlusIcon,
    InboxInIcon,
} from "@heroicons/react/outline";
import { modal } from "components/HeadlessModal";
import { IssueListContext } from "./IssueScreen";
import { useAuth } from "hooks/Auth";
import { toast } from "react-hot-toast";
import { apiDel, apiPut, messageFromException } from "helpers/Request";
import { useContextualHelp } from "hooks/Help";
import { useHistory } from "react-router-dom";
import DangerButton from "components/Buttons/DangerButton";
import SecondaryButton from "components/Buttons/SecondaryButton";

export default function ChannelListToolbar(props) {
    const auth = useAuth();
    const contextualHelp = useContextualHelp();
    const history = useHistory();

    const { selectedItems, load } = useContext(IssueListContext);

    const onRequestArchive = () => {
        const id = toast.loading("Archiving issues...");

        const promises = selectedItems.map((uuid) =>
            apiPut(`/v4/issue/${uuid}`, auth.publication, { status: 0 })
        );
        return Promise.all(promises)
            .then(() => {
                toast.success("Issues archived", { id });
                load();
            })
            .catch((err) => {
                toast.dismiss(id);
                modal.error({
                    title: "Error Archiving Issues",
                    children: messageFromException(err),
                });
            });
    };

    const onRequestDelete = () => {
        modal.warning({
            title: "Delete Issues",
            children: (
                <Fragment>
                    <div>Delete these issues?</div>
                </Fragment>
            ),
            buttons: () => (
                <Fragment>
                    <DangerButton onClick={handleDelete}>Delete</DangerButton>
                    <SecondaryButton onClick={modal.dismiss}>
                        Cancel
                    </SecondaryButton>
                </Fragment>
            ),
        });
    };

    const handleDelete = async () => {
        const id = toast.loading("Deleting issues...");

        const promises = selectedItems.map((uuid) =>
            apiDel(`/v4/issue/${uuid}`, auth.publication)
        );
        return Promise.all(promises)
            .then(() => {
                toast.success("Issues deleted", { id });
                modal.dismiss();
                load();
            })
            .catch((err) => {
                modal.dismiss();
                toast.dismiss(id);
                modal.error({
                    title: "Error Deleting Issues",
                    children: messageFromException(err),
                });
            });
    };

    return (
        <Toolbar>
            <ToolbarGroup>
                <ToolbarButton
                    icon={<PlusIcon />}
                    onClick={() => history.push("/app/planner/issue/new")}
                >
                    Add
                </ToolbarButton>
                <ToolbarButton
                    icon={<TrashIcon />}
                    onClick={onRequestDelete}
                    disabled={!selectedItems.length}
                >
                    Delete
                </ToolbarButton>
                <ToolbarButton
                    icon={<InboxInIcon />}
                    onClick={onRequestArchive}
                    disabled={!selectedItems.length}
                >
                    Archive
                </ToolbarButton>
            </ToolbarGroup>
            <ToolbarGroup className="ml-auto">
                <ToolbarButton
                    icon={<SupportIcon />}
                    className="text-green-600"
                    onClick={() =>
                        contextualHelp.showContextualHelp(
                            "/planner/issues.html"
                        )
                    }
                >
                    Help
                </ToolbarButton>
            </ToolbarGroup>
        </Toolbar>
    );
}
